// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\WidgetBusinessResponse

export type WidgetBusinessApiResponse = {
	name: string;
	logo: string | null;
	timezone: string;
	defaultAddress: string | null;
	defaultPhone: string | null;
	defaultEmail: string | null;
	isWhitelabel: boolean;
	maxFutureBookingDays: number | null;
};

export type WidgetBusiness = {
	name: string;
	logo: string | null;
	timezone: string;
	defaultAddress: string | null;
	defaultPhone: string | null;
	defaultEmail: string | null;
	isWhitelabel: boolean;
	maxFutureBookingDays: number | null;
};

export function hydrateWidgetBusiness(data: WidgetBusinessApiResponse): WidgetBusiness {
	return { ...data };
}